import { render, staticRenderFns } from "./assessment-desktop.vue?vue&type=template&id=0a413169&"
import script from "./assessment-desktop.vue?vue&type=script&lang=ts&"
export * from "./assessment-desktop.vue?vue&type=script&lang=ts&"
import style0 from "./assessment-desktop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports